













import Vue from 'vue'
import { Group } from '@/config/interfaces'
import Pages from '@/components/parsers/Pages.vue'
import WebPush from '@/components/WebPush.vue'

export default Vue.extend({
  name: 'Home',

  components: { Pages, WebPush },

  computed: {
    pageData (): Array<Group> {
      return this.$store.getters.getPageData
    },
    shouldHideMainView (): boolean {
      return this.$vuetify.breakpoint.lgAndUp && this.$store.getters.getLeftViewState
    },
    showPinEnter (): boolean {
      return this.$store.getters.requirePin
    }
  }
})
